/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_SavedInputs */

const en_byoa_saved = /** @type {(inputs: Byoa_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI connection saved.`)
};

const id_byoa_saved = /** @type {(inputs: Byoa_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koneksi AI tersimpan.`)
};

/**
* | output |
* | --- |
* | "AI connection saved." |
*
* @param {Byoa_SavedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_saved = /** @type {((inputs?: Byoa_SavedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_SavedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_saved(inputs)
	return en_byoa_saved(inputs)
});